module.exports = __webpack_public_path__ + "static/media/hotcold.45032bec.png";